export default "__VITE_ASSET__38f4a644__"